import { useMemo } from 'react';
import { Capsule } from '../../../types/capsule';
import { useCapsules } from './useCapsules';

interface UseCapsuleResult {
  capsule: Capsule | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useCapsule(slug: string | null): UseCapsuleResult {
  const { capsules, loading, error, refetch } = useCapsules();

  const capsule = useMemo(() => {
    if (!slug) return null;
    return capsules.find((c) => c.slug === slug) || null;
  }, [capsules, slug]);

  const derivedError = useMemo(() => {
    if (error) return error;
    if (!slug) return 'No capsule specified';
    if (!loading && !capsule) return `Capsule "${slug}" not found`;
    return null;
  }, [capsule, error, loading, slug]);

  return {
    capsule,
    loading,
    error: derivedError,
    refetch,
  };
}
